(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('TypeAssociation', TypeAssociation);

    TypeAssociation.$inject = ['$resource'];

    function TypeAssociation ($resource) {
        var resourceUrl =  'api/type-associations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
